var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{class:['download3', _vm.type],attrs:{"title":"点击下载","href":_vm.apkurl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }